import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02b57761"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shape shape-1" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shape shape-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shape shape-3" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shape shape-4" }, null, -1))
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import {CreationStepName} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import {computed} from 'vue';
    import {useRoute} from 'vue-router';
    import {useStore} from 'vuex';
    import {bool} from 'vue-types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Shapes',
  props: {
        isMaltStrategy: bool().isRequired,
    },
  setup(__props) {

const props = __props;

    

    const store = useStore();
    const route = useRoute();
    const isShapeReversed = computed(() => route.name === CreationStepName.COMPLETION_LINKEDIN);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({shapes: true, 'shapes--strategy': __props.isMaltStrategy, 'shapes--reversed': isShapeReversed.value})
  }, _hoisted_5, 2))
}
}

})